import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showApiErrorToast, showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface CreateNoteData {
  title?: string
  content: string
  contactAccountId?: string | null // null for personal notes, accountId for shared notes
  scope: string
  isShared: boolean
}

const createNote = async (data: CreateNoteData): Promise<string> => {
  const { data: responseData } = await api.post<string>('/note', {
    title: data.title,
    content: data.content,
    contactAccountId: data.contactAccountId || null,
    scope: data.scope,
    isShared: data.isShared,
  })
  return responseData
}

export const useCreateNote = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<string, Error, CreateNoteData>({
    mutationFn: createNote,
    onSuccess: async () => {
      showSuccessToast(t('toast.success'), t('toast.noteCreated'))
      await queryClient.invalidateQueries({ queryKey: ['notes'] })
    },
    onError: (error) => {
      showApiErrorToast(t, error)
    },
  })
}

